// Live dry-run of an alert condition against the champion's latest
// forecast (POST /goals/:goalId/alerts/preview) — the builder dialog's
// preview chart.
const action = "DISCOVERY_PREVIEW_ALERT";
export const REQUEST = action + '_REQUEST';
export const RESPONSE = action + '_RESPONSE';
export const FAILURE = action + '_FAILURE';
export const CLEAR = action + '_CLEAR';

// payload: { goalId, condition }
export const fetchRequest = (payload) => ({ type: REQUEST, payload });
export const fetchSuccess = (response) => ({ type: RESPONSE, payload: response });
export const fetchFailure = (error) => ({ type: FAILURE, payload: error });
export const clearState = () => ({ type: CLEAR });
